<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row items-center">
        <div class="flex flex-row w-full">
          <div class="padding10">
            <span *ngIf="editMode == 'list'">Parent</span>
          </div>
          <div>
            <span *ngIf="editMode == 'add'">Add Parent</span>
          </div>
          <div>
            <span *ngIf="editMode == 'edit'">Replace Parent</span>
          </div>
        </div>

        <div class="flex flex-row">
          <button mat-icon-button *ngIf="editMode == 'list' && parentCount == 0 && !labService.readonly" matTooltip="Add New Parent"
            (click)="addNewParent()" [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list' && parentSelected != null && !labService.readonly" matTooltip="Save New Parent"
            (click)="saveParent()" [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode == 'edit' && !labService.readonly" matTooltip="Delete Parent" (click)="deleteParent()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete
            </mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Cancel" (click)="cancel()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="editMode == 'list' && currentParent != ''">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-row" *ngIf="parentCount == 1">
          <button mat-icon-button matTooltip="{{currentParent}}" (click)="home()" [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">home</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Change {{currentParent}}" (click)="editParent()"
            [matTooltipShowDelay]="750">
            {{currentParent}}
          </button>

        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="editMode !== 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
        'bg-gray-700': sharedService.userTheme === 'dark',
        'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-row" *ngIf="parentCount == 1">
          <span>Current Parent is {{currentParent}}</span>
        </div>
        <div class="flex flex-col" *ngIf="list.length == 0 ">
          <mat-form-field class="flex flex-col mt-4" Style="padding-right:20px">
            <input matInput placeholder="Search Field" [(ngModel)]="search" (keyup.enter)="getParentList()"/>
            <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div>
            <button type="button" mat-raised-button color="primary" (click)="getParentList()">Search</button>
          </div>

        </div>

        <div class="flex flex-col" *ngIf="list.length > 0 ">
          <div class="flex flex-row">
            <mat-form-field class="w-1/4">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full" matSortActive="labName" matSortDirection="desc">
                <ng-container matColumnDef="labId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                  <td mat-cell *matCellDef="let row">
                    <mat-radio-group [(ngModel)]="selected" (change)="radioSelected(row)">
                      <mat-radio-button [value]="row.labId"></mat-radio-button>
                    </mat-radio-group>              
                  </td>
                </ng-container>
                <ng-container matColumnDef="labName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                  <td mat-cell *matCellDef="let change">{{change.labName}}</td>
                </ng-container>
                <ng-container matColumnDef="stateNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>State Number</th>
                  <td mat-cell *matCellDef="let change">{{change.stateNumber}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

</div>

